import { ReactNode } from "react";

export const generateTitleMoveConfirmModal = (info: any): ReactNode => {
  const dropNode = info.node;
  const dragNode = info.dragNode;
  const dropPos = info.node.pos.split("-");
  const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

  if (dropPosition === -1) {
    return (
      <div style={{ fontWeight: 400 }}>
        Xác nhận di chuyển <span style={{ fontWeight: 600 }}>{dragNode.name}</span> lên phía trên{" "}
        <span style={{ fontWeight: 600 }}>{dropNode.name}</span>
      </div>
    );
  }
  if (dropPosition === 0) {
    return (
      <div style={{ fontWeight: 400 }}>
        Xác nhận di chuyển <span style={{ fontWeight: 600 }}>{dragNode.name}</span> vào trong{" "}
        <span style={{ fontWeight: 600 }}>{dropNode.name}</span>
      </div>
    );
  }
  return (
    <div style={{ fontWeight: 400 }}>
      Xác nhận di chuyển <span style={{ fontWeight: 600 }}>{dragNode.name}</span> xuống phía dưới{" "}
      <span style={{ fontWeight: 600 }}>{dropNode.name}</span>
    </div>
  );
};
